$.fn.multiSelectTable = function (o) {
    var defaults = {
        multiselect: true,
        selected: 'selected',
        filter: ' > *',
        rowCheckbox: 'check-taj',
        exclusions: ['action-buttons', 'control-child', 'btn'],
        unselectOn: true,
        keepSelection: true,
        list: $(this).selector,
        e: null,
        element: null,
        start: false,
        stop: false,
        unselecting: false
    };

    return this.each(function (k, v) {
        var options = $.extend({}, defaults, o || {});
        // selector - parent, assign listener to children only
        $(document).on('mousedown', options.list + options.filter, function (e) {
            if (e.which == 1) {
                // DM: HACK pour ne pas que ça coche une row quand on clique une row, dans le cas des UEs liés pour changement VP
                if ($(e.target).closest('tr').attr('id_b00_adresse_ue')) {
                    return true;
                }

                options.e = e;
                options.element = $(this);
                multiSelect(options);
                if ('table' in window) {
                    // Mettre à jour l'info de dataTables
                    if ($('.dataTables_info').next('.datatables_info_select').length === 0) {
                        $('.dataTables_info').css("display", "inline-block");
                        $('.dataTables_info').after('<div class="datatables_info_select" style="display: inline-block;"></div>');
                    }
                    $('.datatables_info_select').empty().append("&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;Sélection de _SELECTED_ élément sur _LENGTH_ élément");
                    var info = table.page.info();
                    $('.datatables_info_select').html($('.datatables_info_select').html().replace(/_SELECTED_/g, $(options.list).find('.' + options.selected).length));
                    $('.datatables_info_select').html($('.datatables_info_select').html().replace(/_LENGTH_/g, info.length));
                }
            }
            return true;
        });

        if (options.unselectOn) {
            // event to unselect

            $(document).on('mousedown', options.unselectOn, function (e) {
                if (!$(e.target).parents().is(options.list) && e.which != 3 && !$(e.target).hasClass('btn') && (e.target != $('div.dataTables_scrollBody')[0])) {
                    // On vérifie qu'on ne travaille pas dans un modal. Si c'est le cas, ce n'est pas un clic dans un document pour annuler la sélection.
                    if ($('.modal.in').length === 0) {
                        $(options.list + ' .' + options.selected).find('input.' + options.rowCheckbox).prop('checked', false).trigger("change");
                        $(options.list + ' .' + options.selected).removeClass(options.selected);
                        // Mettre à jour l'info de dataTables. On retire le div utilisé pour la sélection
                        if ('table' in window) {
                            $('.datatables_info_select').empty();
                        }
                        if (options.unselecting != false) {
                            options.unselecting();
                        }
                    }
                }
            });
        }
    });
};

function multiSelect(o) {

    var target = o.e.target;
    var list;
    if (!$(target).parents().hasClasses(o.exclusions)) {

        var element = o.e.target.closest('tr');
        list = o.list;

        if (o.start != false) {
            var start = o.start(o.e, $(element));
            if (start == false) {
                return false;
            }
        }

        if (o.e.shiftKey && o.multiselect) {
            // get one already selected row
            $(element).addClass(o.selected);
            $(element).find('input.' + o.rowCheckbox).prop('checked', true).trigger("change");
            var first = $(o.list).find('.' + o.selected).first().index();
            var last = $(o.list).find('.' + o.selected).last().index();

            // if we hold shift and try to select last element that is upper in the list
            if (last < first) {
                var firstHolder = first;
                first = last;
                last = firstHolder;
            }

            if (first == -1 || last == -1) {
                return false;
            }

            $(o.list).find('.' + o.selected).removeClass(o.selected);

            var num = last - first;
            var x = first;

            for (var i = 0; i <= num; i++) {
                $(list).find(o.filter + "> tr").eq(x + 1).addClass(o.selected);
                $(list).find(o.filter + "> tr").eq(x + 1).find('input.' + o.rowCheckbox).prop('checked', true).trigger("change");
                x++;
            }
        } else if ((o.e.ctrlKey || o.e.metaKey) && o.multiselect) {
            if ($(target).prev(':checkbox').hasClass(o.rowCheckbox) && !$(element).hasClass(o.selected)) {
                $(element).addClass(o.selected);
            } else if ($(target).prev(':checkbox').hasClass(o.rowCheckbox) && $(element).hasClass(o.selected)) {
                $(element).removeClass(o.selected);
            } else {
                if ($(element).hasClass(o.selected)) {
                    $(element).find('input.' + o.rowCheckbox).prop('checked', false).trigger("change");
                    $(element).removeClass(o.selected);
                } else {
                    $(element).addClass(o.selected);
                    $(element).find('input.' + o.rowCheckbox).prop('checked', true);
                    cocherDecocherEvenementsLies(o);
                }
            }
        } else {
            if (o.keepSelection && !$(element).hasClass(o.selected)) {
                $(list).find('.' + o.selected).find('input' + o.rowCheckbox).prop('checked', false).trigger("change");
                $(list).find('.' + o.selected).removeClass(o.selected);
                $(element).addClass(o.selected);
                $(element).find('input' + o.rowCheckbox).prop('checked', true);
            } else {
                // Si on utilise une case à cocher, on ne doit pas tout sélectionner parce qu'elle ne se coche pas par la suite.
                if ($(target).prev(':checkbox').hasClass(o.rowCheckbox) && !$(element).hasClass(o.selected)) {
                    $(element).addClass(o.selected);
                    cocherDecocherEvenementsLies(o);
                } else if ($(target).prev(':checkbox').hasClass(o.rowCheckbox) && $(element).hasClass(o.selected)) {
                    $(element).removeClass(o.selected);
                    cocherDecocherEvenementsLies(o);
                } else {
                    $(list).find('.' + o.selected).find('input.' + o.rowCheckbox).prop('checked', false).trigger("change");
                    $(list).find('.' + o.selected).removeClass(o.selected);
                    $(element).addClass(o.selected);
                    var elementInputChecked = true;
                    $(element).find('input.' + o.rowCheckbox).prop('checked', elementInputChecked);
                    cocherDecocherEvenementsLies(o);
                }
            }
            if ('table' in window) {
                if ($(list).find('.' + o.selected).length === 0) {
                    $('.datatables_info_select').empty();
                }
            }
        }

        if (o.stop != false) {
            o.stop($(list).find('.' + o.selected), $(element));
        }
    }
    else {
        // On décoche tout
        if (!$(target).hasClasses(['fa-caret-right', 'fa-caret-down'])) {
            list = o.list;
            $(list).find('.' + o.selected).find('input.' + o.rowCheckbox).prop('checked', false).trigger("change");
            $(list).find('.' + o.selected).removeClass(o.selected);
        }

    }
}

function cocherDecocherEvenementsLies(o) {
    var target = o.e.target;
    var targetInputOrMultiSelect = target.nodeName === 'TD' ? $(target).closest('tr').find('td.control-child').find('i') : $(target).closest('td').prev('td').find('i');
    if (targetInputOrMultiSelect.length > 0) {
        // On affiche les évènements multiples s'ils ne le sont pas déjà. Sur désélection, on ne referme pas la table "details-table-X".
        if (target.nodeName === 'TD' && !($(target).hasClass('control-child'))) { // On clique dans n'importe quelle cellule du tableau.
            $(target).closest('tr').off('click').on('click', function () {
                $(target).closest('tr').find('td.control-child').trigger("click");
                var childControlSelected = true;
                var childControlMethod = 'addClass';
                $('#details-table-' + $(target).closest('tr').find('input.' + o.rowCheckbox).attr('id')).find('tr')[childControlMethod](o.selected);
                $('#details-table-' + $(target).closest('tr').find('input.' + o.rowCheckbox).attr('id')).find('input.' + o.rowCheckbox).prop('checked', childControlSelected);
                $(target).closest('tr').find('td.control-child').next('td').find('input.' + o.rowCheckbox).trigger('click');
            });
        } else { // On clique sur un input checkbox du tableau.
            $(target).prev('input.' + o.rowCheckbox).off('click').on('click', function () { // On déclenche des actions dans un callback puisque details-table-x doit être présente à l'écran avant de manipuler le DOM
                var childControlSelected = $(target).prev('input').prop('checked');
                var childControlMethod = (childControlSelected ? 'addClass' : 'removeClass');
                $('#details-table-' + $(target).prev('input.' + o.rowCheckbox).attr('id')).find('tr')[childControlMethod](o.selected);
                $('#details-table-' + $(target).prev('input.' + o.rowCheckbox).attr('id')).find('input.' + o.rowCheckbox).prop('checked', childControlSelected);
            });
            // On valide qu'il n'y a pas de décalage entre l'ouverture et la fermeture des évènements liés avant de cocher/décocher les lignes.
            if ((($(target).closest('td').prev('td').find('i.fa-caret-down').length > 0) && ($(target).prev('input.' + o.rowCheckbox).prop('checked') === true)) || (($(target).closest('td').prev('td').find('i.fa-caret-right').length > 0) && !($(target).prev('input.' + o.rowCheckbox).prop('checked') === true))) {
                $(target).closest('td').prev('td.control-child').trigger("click");
            }
        }
    } else if (target.nodeName === 'TD') { // On active seulement le input
        $(target).closest('tr').find('input.' + o.rowCheckbox).trigger("click");
    }
}